import { getLocaleDateTimeString, history } from '../utils';
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import React from 'react';
import { SeverityPill } from '../components/Redesing/severity-pill';

export const couponColumns = [
  {
    id: 'name',
    label: 'Name',
    searchable: true,
    format: (row) => {
      return row.name ? row.name : <SeverityPill color={'info'}>N/A</SeverityPill>;
    },
  },
  {
    id: 'scope',
    label: 'Scope',
    format: (row) => {
      const isOrg = row.organizationId != null && row.organizationId !== '';
      return (
        <SeverityPill color={isOrg ? 'warning' : 'info'}>
          {isOrg ? 'Organization' : 'System'}
        </SeverityPill>
      );
    },
  },
  {
    id: 'active',
    label: 'Status',
    format: (row) => {
      return row.active ? (
        <SeverityPill color={'success'}>Active</SeverityPill>
      ) : (
        <SeverityPill color={'error'}>Inactive</SeverityPill>
      );
    },
  },
  {
    id: 'actions',
    label: 'Actions',
    shouldNotExport: true,
    format: (row) => {
      const isOrg = row.organizationId != null && row.organizationId !== '';
      const target = isOrg
        ? `/organization/billing/coupon/edit/${row.gid ?? row.id}`
        : `/billing/coupon/edit/${row.id}`;
      return (
        <div style={{ display: 'flex', justifyContent: 'flex-start', maxWidth: '10px' }}>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              history.push(target);
            }}
          >
            <EditIcon />
          </IconButton>
        </div>
      );
    },
    notSortable: true,
  },
  {
    id: 'code',
    label: 'Code',
    searchable: true,
    format: (row) => {
      return row.code ? row.code : <SeverityPill color={'info'}>N/A</SeverityPill>;
    },
  },
  {
    id: 'discount',
    label: 'Discount',
    format: (row) => {
      return row.discount ? (
        row.discount
      ) : (
        <SeverityPill color={'info'}>N/A</SeverityPill>
      );
    },
  },

  {
    id: 'duration',
    label: 'Valid',
    format: (row) => {
      if (row.duration == null) {
        return row.uses;
      }
      return row.duration;
    },
  },
  {
    id: 'created',
    label: 'Created',
    format: (row) => {
      return row.created ? getLocaleDateTimeString(row.created) : '';
    },
  },
];
